import { useApiAvailability } from "@babackapp/private-api-client/client/use-api-availability";
import { Loader2Icon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useWidgetUnavailableReason } from "../hooks/use-widget-unavailable-reason";
import { WidgetUnavailable } from "./widget-unavailable";

// Suspense fallback for the widget boot. Used to be an empty white box, which is
// indistinguishable from a hung backend. It doubles as the outage surface, because a
// request that never settles keeps the tree suspended forever — the gate below the
// boundary would never render.
export function WidgetLoading() {
  const reason = useWidgetUnavailableReason();
  const availability = useApiAvailability();
  const { t } = useTranslation("return-widget-v3", { useSuspense: false });

  return (
    <div className="flex h-screen w-screen flex-col bg-white">
      {reason ? (
        <WidgetUnavailable reason={reason} />
      ) : (
        <div className="flex flex-1 flex-col items-center justify-center gap-3">
          <Loader2Icon className="text-muted-foreground size-6 animate-spin" />
          {availability === "slow" && (
            <p className="font-content text-muted-foreground max-w-xs text-center text-sm">
              {t("common.slow.description", {
                defaultValue: "This is taking longer than usual. Hang on a moment…",
              })}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
